var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuIconApplicationActive = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.33333 4H4.88889C4.39797 4 4 4.39797 4 4.88889V9.33333C4 9.82427 4.39797 10.2222 4.88889 10.2222H9.33333C9.82427 10.2222 10.2222 9.82427 10.2222 9.33333V4.88889C10.2222 4.39797 9.82427 4 9.33333 4Z",
  stroke: "#47E1E7",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33333 13.7778H4.88889C4.39797 13.7778 4 14.1758 4 14.6667V19.1112C4 19.6021 4.39797 20.0001 4.88889 20.0001H9.33333C9.82427 20.0001 10.2222 19.6021 10.2222 19.1112V14.6667C10.2222 14.1758 9.82427 13.7778 9.33333 13.7778Z",
  stroke: "#47E1E7",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1107 4H14.6662C14.1753 4 13.7773 4.39797 13.7773 4.88889V9.33333C13.7773 9.82427 14.1753 10.2222 14.6662 10.2222H19.1107C19.6016 10.2222 19.9996 9.82427 19.9996 9.33333V4.88889C19.9996 4.39797 19.6016 4 19.1107 4Z",
  stroke: "#47E1E7",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1107 13.7778H14.6662C14.1753 13.7778 13.7773 14.1758 13.7773 14.6667V19.1112C13.7773 19.6021 14.1753 20.0001 14.6662 20.0001H19.1107C19.6016 20.0001 19.9996 19.6021 19.9996 19.1112V14.6667C19.9996 14.1758 19.6016 13.7778 19.1107 13.7778Z",
  stroke: "#47E1E7",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuIconApplicationActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MenuIcon_Application_active.9c6ea7406eca779d0c296e5ccec85d9e.svg";